import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  { path: 'assessment', redirectTo: 'assessment/list', pathMatch: 'full' },
  {
    path: 'assessment',
    children: [
      {
        path: 'list',
        loadComponent: () => import('./list/assessment.component').then((m) => m.AssessmentComponent),
      },
      {
        path: 'results',
        loadComponent: () => import('./results/assessment-results.component').then((m) => m.AssessmentResultsComponent),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class assessmentRoutingModule {
  static routes = admin;
}
